<template>
    <div style="display: flex;background-color: white;height: 100%;">

        <div class="left-tree">
            <a-page-header title="组织结构" />
            <a-input-search v-model:value="searchTreeValue" style="margin-bottom: 8px" placeholder="Search" />
            <a-tree 
                v-model:selectedKeys="selectedKeys"
                v-model:fieldNames="fieldName"
                :tree-data="treeData">
                <template #title="{ name }">
                    <span v-if="name.indexOf(searchTreeValue) > -1">
                        {{ name.substring(0, name.indexOf(searchTreeValue)) }}
                        <span style="color: #f50">{{ searchTreeValue }}</span>
                        {{ name.substring(name.indexOf(searchTreeValue) + searchTreeValue.length) }}
                    </span>
                    <span v-else>{{ name }}</span>
                </template>

            </a-tree>
        </div>

        <div class="my-custom-table">
            <a-page-header title="组织列表" />
            <div class="search-bar">
                <div class="tabInput">
                    <a>组织名称：</a>
                    <a-input v-model:value="deptName" placeholder="请输入组织名称进行搜索" class="search-input" />
                </div>
                <div class="tab-button">
                    <div>
                        <a-button class="search-tow" type="primary" @click="onSearch"
                            :icon="h(SearchOutlined)">搜索</a-button>
                        <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                    </div>
                    <div class="right-option">
                        <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">添加</a-button>
                        <!-- 添加数据 -->
                        <addComponent ref="childOpen" />
                    </div>
                </div>
            </div>
            <a-table :columns="columns" :data-source="data" :pagination="pagination" row-key="id">
                <template #bodyCell="{ column, text, record }">
                    <!-- 渲染颜色 -->
                    <template v-if="column.key === 'deptName' && !editableData[record.id]">
                        <a>
                            {{ record.deptName }}
                        </a>
                    </template>
                    <template v-if="column.key === 'deptCode' && !editableData[record.id]">
                        <span>
                            <a-tag color="green">
                                {{ record.deptCode }}
                            </a-tag>
                        </span>
                    </template>
                    <!-- 渲染修改项 -->
                    <template v-if="['deptName', 'deptCode', 'deptSort'].includes(column.dataIndex)">
                        <div>
                            <a-input v-if="editableData[record.id]"
                                v-model:value="editableData[record.id][column.dataIndex]" style="margin: -5px 0" />
                            <template v-else>
                                <span v-if="column.key != 'deptName' && column.key != 'deptCode'">
                                    {{ text }}
                                </span>
                            </template>
                        </div>
                    </template>

                    <!-- 渲染操作按钮 -->
                    <template v-if="column.dataIndex === 'operation'">
                        <div class="editable-row-operations">
                            <span v-if="editableData[record.id]">
                                <a-popconfirm title="确认保存？" ok-text="是" cancel-text="否" @confirm="save(record.id)">
                                    <a-tag @click="cancel(record.id)" color="#108ee9">
                                        <a style="margin: 15px;">取消</a>
                                    </a-tag>
                                    <a-tag color="#108ee9">
                                        <a style="margin: 15px;">保存</a>
                                    </a-tag>
                                </a-popconfirm>
                            </span>
                            <span v-else>
                                <a @click="edit(record.id)">修改</a>
                                <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                                    <a style="margin: 15px;">删除</a>
                                </a-popconfirm>
                            </span>
                        </div>
                    </template>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
import { deptPage, updateDepts, removeDept, treeDepts } from '@/api/service';
import { cloneDeep } from 'lodash-es';
import { message } from 'ant-design-vue';
import { SearchOutlined, RedoOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';
import { ref, reactive, h, watch } from 'vue';
import addComponent from './modal/addComponent.vue'; // 导入组件

export default {
    name: 'UserDeptPage',
    components: {
        addComponent
    },
    setup() {
        const data = ref([]); // 初始化为空数组
        const deptName = ref('');//查询条件
        const parentId = ref('')//查询条件
        const childOpen = ref(null);//子页面实例
        const searchTreeValue = ref(''); // 树形结构查询条件
        const treeData = ref([]);//树形结构
        const selectedKeys = ref([]);//选中节点
        const fieldName = {children:'children', title:'name', key:'id'};
        const pagination = ref({
            current: 1, // 当前页数
            pageSize: 10, // 每页显示条数
            total: 0, // 数据总数
            showSizeChanger: true, // 是否显示修改每页条数
            showQuickJumper: true, // 是否显示快速跳转
            onChange: (page, pageSize) => {
                pagination.value.current = page;
                pagination.value.pageSize = pageSize;
                list(); // 当分页改变时，重新获取数据
            },
            position: ['bottomLeft']//显示位置
        });
        //列表
        const columns = [
            { title: '组织名称', dataIndex: 'deptName', key: 'deptName', width: '10%', },
            { title: '组织代码', dataIndex: 'deptCode', key: 'deptCode', width: '10%', },
            { title: '上级组织', dataIndex: 'parentName', key: 'parentName', width: '10%', },
            { title: '排序', dataIndex: 'deptSort', key: 'deptSort', width: '10%', },
            { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt', width: '10%', },
            { title: '操作', dataIndex: 'operation', width: '10%', },
        ];

        //查询数据
        const list = async () => {
            const response = await deptPage({
                pageNumber: pagination.value.current,
                pageSize: pagination.value.pageSize,
                deptName: deptName.value,
                parentId: parentId.value
            });
            if (response.code === 200) {
                pagination.value.total = response.totalRow || response.data.totalRow || response.data.total || 0; // 更新 total
                data.value = response.data.records.map(item => ({
                    id: item.id,
                    deptName: item.deptName,
                    deptCode: item.deptCode,
                    parentName: item.parentName,
                    deptSort: item.deptSort,
                    createdAt: item.createdAt,
                }));
            }
        };
        //查询树形结构
        const tree = async () => {
            const response = await treeDepts({});
            if (response.code === 200) {
                treeData.value = response.data.records;
                console.log(treeData.value);
            }
        };
        //树形结构选择
        watch(selectedKeys, () => {
            parentId.value = selectedKeys.value.at(0)===undefined ? '' : selectedKeys.value.at(0);
            list();
        });
        // 组件初始化时调用一次
        list();
        tree();
        //修改数据
        const updateDept = async (data) => {
            const response = await updateDepts(data);
            if (response.code === 200) {
                message.success('修改成功');
                return true;
            } else {
                message.error('修改错误：' + response.msg);
                return false;
            }
        };
        //删除菜单
        const deleteDept = async (data) => {
            const response = await removeDept(data);
            if (response.code === 200) {
                message.success('删除成功');
                return true;
            } else {
                message.error('删除失败' + response.msg);
                return false;
            }
        };
        //修改的数据
        const editableData = reactive({});
        //修改按钮
        const edit = id => {
            editableData[id] = cloneDeep(data.value.filter(item => id === item.id)[0]);
        };
        //修改保存
        const save = id => {
            if (updateDept(editableData[id])) {
                Object.assign(data.value.filter(item => id === item.id)[0], editableData[id]);
                delete editableData[id];
            }
        };
        //关闭修改
        const cancel = id => {
            delete editableData[id];
        };
        //删除
        const remove = id => {
            if (deleteDept(id)) {
                data.value = cloneDeep(data.value.filter(item => id != item.id));
            }
        };
        //搜索
        const onSearch = () => {
            pagination.value.current = 1; // 搜索时重置当前页数
            list();
        }
        //重置
        const onReset = () => {
            deptName.value = ''; // 重置搜索关键词
            list(); // 重置后重新获取数据
        }
        //添加
        const toAdd = () => {
            childOpen.value.open = true;
        }
        return {
            columns,
            pagination,
            data,
            editableData,
            deleteDept,
            SearchOutlined,
            RedoOutlined,
            PlusCircleOutlined,
            onSearch,
            onReset,
            addComponent,
            searchTreeValue,
            toAdd,
            childOpen,
            ref,
            h,
            remove,
            deptName,
            updateDept,
            cancel,
            save,
            edit,
            list,
            tree,
            selectedKeys,
            fieldName,
            treeData,
        };
    },
};
</script>
<style>
.tabInput {
    margin-left: 10px;
    width: 20%;
}
</style>